// eslint-disable-next-line import/prefer-default-export
export const GLOBAL_MEDIA_QUERIES = {
  mobile: '(max-width: 767px)', // mobile-tablet
  desktop: '(min-width: 768px)', // desktop
};
